import React, { useEffect, useState } from 'react';
import Button from '../Button';
import Form, { useForm } from '../Form';
import Field from '../Field';
import { StyledCreatProjectModal } from './CreatProjectModal.style';
import projectService from '../../services/projectService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../Toast';

const CreatProjectModal = ({ onClose, isEdit }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async e => {
      if (isEdit) {
        const editPayload = {
          ...e,
          project_id: isEdit?.project_id,
        };
        return await projectService.updateProject(editPayload);
      } else {
        return await projectService.createProject({
          ...e,
          session: [],
        });
      }
    },
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['get_all_projects'] });
      onClose();
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  const handleSubmit = async e => {
    mutation.mutate(e);
  };

  const [form] = useForm();
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: isEdit?.name,
        description: isEdit?.description,
      });
    }
  }, []);

  return (
    <StyledCreatProjectModal>
      <div className="content-box">
        <p>
          Projects offer a structured way to organize your chats and utilize source of truth to help you and your team
          do more.
        </p>
        <Form form={form} onSubmit={handleSubmit}>
          <div className="input-holder">
            <Form.Item
              label="Name"
              type="text"
              rounded
              name="name"
              placeholder="Example: Quarterly Planning & Research"
              rules={[
                {
                  required: true,
                  message: 'Name is Required',
                },
              ]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Description"
              type="textarea"
              rounded
              name="description"
              placeholder="This project is a collection of threads related to planning..."
              rules={[
                {
                  required: true,
                  message: 'Description is Required',
                },
              ]}>
              <Field />
            </Form.Item>
          </div>
          {/* <div className="text-holder">
            <strong className="title">Share Access</strong>
            <p>Chose who has access to view or contribute.</p>
            <Button variant="outline" onClick={() => onClose()}>
              Manage Share Settings
            </Button>
          </div> */}
          <div className="btn-holder">
            <Button width="150px" variant="secondary-outline" onClick={() => onClose()}>
              Cancel
            </Button>
            <Button width="150px" disabled={mutation?.isPending} loader={mutation?.isPending}>
              Create Project
            </Button>
          </div>
        </Form>
      </div>
    </StyledCreatProjectModal>
  );
};

export default CreatProjectModal;
